module.exports = __webpack_public_path__ + "static/img/shopee-logo-placeholder.f8f6327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shopee-logo-placeholder.png
// module id = fixC
// module chunks = 31